import { render, staticRenderFns } from "./product-category-tree.vue?vue&type=template&id=03d5f126&scoped=true&"
import script from "./product-category-tree.vue?vue&type=script&lang=js&"
export * from "./product-category-tree.vue?vue&type=script&lang=js&"
import style0 from "./product-category-tree.vue?vue&type=style&index=0&id=03d5f126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5f126",
  null
  
)

export default component.exports